import React, {Component} from 'react';
import {Footer, NavBar, Session} from "../../components";
import {VIEW_NAME, config} from "../../libs/utils/Const";
//import './AboutUsView.css';

class AboutUsView extends Component {
    render() {
        const {history} = this.props;
        const {mission, images, description, vision, values} = config.aboutUs;
        return (
            <div className="content-fluid" style={{marginTop: 66}}>
                <Session history={history} view={VIEW_NAME.ABOUT_US_VIEW}/>
                <NavBar/>
                <div className="container" style={{paddingTop:60}}>
                    <div className="row ">
                        <div className="col">
                            <div className="jumbotron">
                                <h1 className="display-4">¿Quiénes somos?</h1>
                                <p>{description}</p>
                                <hr className="my-4"></hr>
                                <div className="text-center">
                                    <img src={images} className="img-fluid" alt="Familia CIG"></img>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-4">
                            <div className="list-group" id="list-tab" role="tablist" >
                                {!!mission && <a className="list-group-item list-group-item-action-1 active"
                                id="list-home-list" data-toggle="list" href="#list-home"
                                role="tab" aria-controls="home">
                                    Misión
                                </a>}
                                { !!vision && <a className="list-group-item list-group-item-action-1"
                                id="list-profile-list" data-toggle="list"
                                href="#list-profile" role="tab"
                                aria-controls="profile">
                                    Visión
                                </a>}
                                { !!values.length && <a className="list-group-item list-group-item-action-1"
                                id="list-messages-list" data-toggle="list"
                                href="#list-messages" role="tab"
                                aria-controls="messages">
                                Valores
                                </a>}
                            </div>
                        </div>
                        <div className="col-sm-8">
                            <div className="tab-content" id="todo-rojo">
                                { !!mission && <div className="tab-pane fade show active" id="list-home" role="tabpanel" aria-labelledby="list-home-list">
                                    {mission}
                                </div>}
                                { !!vision && <div className="tab-pane fade" id="list-profile" role="tabpanel" aria-labelledby="list-profile-list">
                                    {vision}
                                </div>}
                                { !!values.length && <div className="tab-pane fade" id="list-messages" role="tabpanel" aria-labelledby="list-messages-list">
                                    <ul className="list-group list-group-flush">
                                        {values.map( value => {
                                            return  <li key={value.title} className="list-group-item">{value.title}</li>
                                        } )}
                                    </ul>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AboutUsView;